import { US_STATES } from "../../../../../../constants";

// Ownership type options - showing actual database values
export const OWNERSHIP_TYPE_OPTIONS = [
  { label: 'Sole Proprietor', value: 'sole' },
  { label: 'Partnership', value: 'partnership' },
  { label: 'Corporation', value: 'corporation' },
  { label: 'LLC', value: 'llc' }
];

export const US_STATE_OPTIONS = Object.entries(US_STATES).map(([, value]) => ({
  label: value,
  value: value,
}));

export const BILLING_SEQUENCE_OPTIONS = [
  { label: 'Daily', value: 'daily' },
  { label: 'Monthly', value: 'monthly' }
];

export const EXPEDITED_FUNDING_OPTIONS = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' }
];

export const DOCUMENT_TYPE_OPTIONS = [
  { label: "Driver's License", value: 'LOCAL_STATE_ID' },
  { label: 'Passport', value: 'PASSPORT' },
  { label: 'State ID', value: 'STATE_ID' },
];

// Fields that should be rendered as dropdowns
export const DROPDOWN_FIELDS = {
  // EMS processor
  'OwnershipType': {
    options: OWNERSHIP_TYPE_OPTIONS
  },
  // NAB (North) processor
  'businessType': {
    options: OWNERSHIP_TYPE_OPTIONS
  },
  // Nuvei processor
  'OwnershipType': {
    options: OWNERSHIP_TYPE_OPTIONS
  },
  // Priority processor - no ownership type field in JSON structure
  // Payliance processor
  'type': {
    options: OWNERSHIP_TYPE_OPTIONS
  },
  'billingSequence': {
    options: BILLING_SEQUENCE_OPTIONS
  },
  'expeditedFunding': {
    options: EXPEDITED_FUNDING_OPTIONS
  },
  'DocumentType': {
    options: DOCUMENT_TYPE_OPTIONS
  },
  'DocumentState': {
    options: US_STATE_OPTIONS
  }
};

export const TEXTAREA_FIELDS = [
  'specialInstruction',
  'UDWNotes',
  'appPdfBundle'
]; 